import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

const EVENT_CATEGORY = 'Product reviews';

/** Every reviews event on the PDP goes through here, so they share one category. */
export const sendProductReviewsEvent = (event_action: string, event_label: string) => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_action,
      event_category: EVENT_CATEGORY,
      event_label,
    }),
  );
};
